import { render, staticRenderFns } from "./BackhaulDashboard.vue?vue&type=template&id=de1ae1e4"
import script from "./BackhaulDashboard.vue?vue&type=script&lang=js"
export * from "./BackhaulDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports